import { Link } from "@tanstack/react-router";
import { LayoutGridTwoCols } from "./Layout/LayoutGridTwoCols";
import { TeaserImage } from "./TeaserImage";
import { Button } from "./ui/button";
import { RichTextRenderer } from "~/components/RichTextRenderer";

export const TeaserHorizontal = ({
  eyebrow,
  title,
  description,
  image,
  link,
  ctaLabel,
  inverted,
}: {
  eyebrow: string;
  title: string;
  description: string;
  image: string;
  link: string;
  ctaLabel: string;
  inverted?: boolean;
}) => {
  return (
    <LayoutGridTwoCols>
      <TeaserImage image={image} alt="" className={inverted ? "order-2" : ""} />
      <div className={inverted ? "order-1" : ""}>
        <p className="text-base font-semibold">{eyebrow}</p>
        <h2 className="mt-6 text-5xl font-medium">{title}</h2>
        <RichTextRenderer
          additionalClasses="text-lg mt-6"
          richText={description}
        />
        <Button asChild size={"lg"}>
          <Link to={link} className="mt-6 flex items-center gap-1">
            {ctaLabel}
          </Link>
        </Button>
      </div>
    </LayoutGridTwoCols>
  );
};
